/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  var printtext = "";
  $on('pageInit', function () {
    $f7.request.get('http://temp/json/jackpot.aspx?user=' + localStorage.getItem("username") + '&pass=' + localStorage.getItem("password")).then(function (res) {
      var raw = res.data;
      var data = JSON.parse(raw);

      for (var i = 0; i < data.downline.length; i++) {
        printtext += "\n            <tr>\n              <td class=\"label-cell\">" + data.downline[i].usernane + "</td>\n              <td class=\"numeric-cell\">" + data.downline[i].buytype + "</td>\n            </tr>\n          ";
      }

      $update();
    });
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">Jackpot</div>
    </div>
  </div>
  <div class="page-content">
    <div class="block-title block-title-large">Jackpot</div>
      <div class="block">
        <p>
          The jackpot number
          <br/><br/>
          <div class="card data-table">
            <table>
              <thead>
                <tr>
                  <th class="label-cell">Username</th>
                  <th class="numeric-cell">Buytype</th>
                </tr>
              </thead>
              <tbody innerHTML=${printtext}>
                <tr>
                  <td class="label-cell">OrderID</td>
                  <td class="numeric-cell">abc</td>
                </tr>
              </tbody>
            </table>
          </div>
        </p>
    </div>
  </div>
</div>
`
    }
    ;
}

framework7Component.id = '6c441da0e2';
export default framework7Component;